export default __webpack_public_path__ + "static/media/fillingPotion.74831d22.mp3";